module.exports = __webpack_public_path__ + "media/images/shared/icon-assistant-professors-approval-2cf6d115b4de4de31cfe1a03a4852427.png";